/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 */

/**
 * Generated types for CHIRP model: com.hubspot.copilot.models.chat.AblyMessage
 *
 * [View Java Source](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+AblyMessage)
 */

export const ABLY_MESSAGE_MODEL_FINGERPRINT = 'LrrHnFVEJdg=';

/** Generated avro schema for subtype base com.hubspot.copilot.models.chat.AblyMessage */

/** Generated avro schema for source immutable com.hubspot.copilot.models.chat.ChatRequestIF */

/**  Defines input for interactive tools with pre-built JSON schema and action context.
 */

/** Generated avro schema for source immutable com.hubspot.copilot.models.chat.tools.interactive.FrontEndToolIF */

/** Generated avro schema for source immutable com.hubspot.copilot.models.chat.tools.interactive.DependentToolIF */

/** Generated avro schema for source immutable com.hubspot.copilot.models.chat.ChatRequestContextIF */

/** Generated avro schema for source immutable com.hubspot.copilot.models.chat.PageContextIF */

/** Generated avro schema for source immutable com.hubspot.copilot.models.chat.CrmObjectContextIF */

/** Generated avro schema for source immutable com.hubspot.copilot.models.chat.AppSearchScopeIF */

/** Generated avro schema for source immutable com.hubspot.copilot.models.fileupload.FileInfoIF */

/** Generated avro schema for source immutable com.hubspot.copilot.models.chat.MessageTrackingIF */

/** Generated avro schema for source immutable com.hubspot.copilot.models.chat.ActionRequestIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.useraction.UserActionToolInputIF */

/** Generated avro schema for subtype base com.hubspot.chirp.ext.models.FieldValue */

/** Generated avro schema for source immutable com.hubspot.chirp.ext.models.FieldValue.NullFieldValueIF */

/** Generated avro schema for source immutable com.hubspot.chirp.ext.models.FieldValue.BooleanFieldValueIF */

/** Generated avro schema for source immutable com.hubspot.chirp.ext.models.FieldValue.DoubleFieldValueIF */

/** Generated avro schema for source immutable com.hubspot.chirp.ext.models.FieldValue.FloatFieldValueIF */

/** Generated avro schema for source immutable com.hubspot.chirp.ext.models.FieldValue.IntFieldValueIF */

/** Generated avro schema for source immutable com.hubspot.chirp.ext.models.FieldValue.LongFieldValueIF */

/** Generated avro schema for source immutable com.hubspot.chirp.ext.models.FieldValue.StringFieldValueIF */

/** Generated avro schema for source immutable com.hubspot.chirp.ext.models.FieldValue.ListFieldValueIF */

/** Generated avro schema for source immutable com.hubspot.chirp.ext.models.FieldValue.MapFieldValueIF */

/**  Response to a confirmation request. Sent from frontend to backend.
 Contains the message with the updated confirmation section along with whether the action was confirmed.
 */

/** Generated avro schema for source immutable com.hubspot.copilot.models.chat.AbstractMessage */

/**  Represents feedback provided for a copilot message.
 */

/** Generated avro schema for subtype base com.hubspot.chatspot.message.schemas.sections.ResponseSection */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.AbstractActionsResponseSection */

/** Generated avro schema for subtype base com.hubspot.chatspot.message.schemas.buttons.Button */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.buttons.ActionButtonIF */

/** Generated avro schema for subtype base com.hubspot.chatspot.intent.schemas.base.ActionPayload */

/** Generated avro schema for source immutable com.hubspot.chatspot.intent.schemas.chatspot.AskAcademyRequestIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.intent.schemas.chatspot.AskInAppHelpRequestIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.intent.schemas.chatspot.CompanyCompetitorsRequestIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.intent.schemas.chatspot.CompanyFundingRequestIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.intent.schemas.chatspot.CompanyLookupRequestIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.intent.schemas.chatspot.CompanyTechRequestIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.intent.schemas.chatspot.CopilotCapabilitiesRequestIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.intent.schemas.chatspot.CreateBlogPostRequestIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.intent.schemas.chatspot.CreateNewsSubscriptionRequestIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.intent.schemas.chatspot.CustomSystemPromptRequestIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.intent.schemas.chatspot.DeleteNewsSubscriptionRequestIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.intent.schemas.chatspot.DiscoverCompaniesRequestIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.intent.schemas.chatspot.DraftBlogPostRequestIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.intent.schemas.chatspot.DraftSalesEmailRequestIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.intent.schemas.chatspot.ImageGenerateRequestIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.intent.schemas.chatspot.ListNewsSubscriptionsRequestIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.intent.schemas.chatspot.ListNotesRequestIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.intent.schemas.chatspot.NewsRequestIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.intent.schemas.chatspot.NoteCreateRequestIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.schemas.base.ResolvedObjectIF */

/** Generated avro schema for source immutable com.hubspot.crm.objects.AbstractObjectCoordinates */

/** Generated avro schema for source immutable com.hubspot.chatspot.intent.schemas.chatspot.ObjectAddRequestIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.intent.schemas.chatspot.ObjectAssignRequestIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.schemas.base.ResolvedOwnerIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.intent.schemas.chatspot.ObjectAssociationsRequestIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.intent.schemas.chatspot.ObjectCountRequestIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.intent.schemas.chatspot.ObjectListRequestIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.schemas.base.ResolvedSearchFilterIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.schemas.base.ResolvedSearchSortIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.intent.schemas.chatspot.ObjectSummaryRequestIF */

/** Generated avro schema for source protobuf com.hubspot.properties.data.PropertiesProtos.PropertyValue */

/** Generated avro schema for source immutable com.hubspot.chatspot.intent.schemas.chatspot.ObjectUpdateRequestIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.intent.schemas.chatspot.OrchestrationPlanningRequestIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.intent.schemas.chatspot.OrchestrationPlanExecutionRequestIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.intent.schemas.chatspot.ReportBuilderRequestIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.intent.schemas.chatspot.SummarizeArticleRequestIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.intent.schemas.chatspot.TaskCreateRequestIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.schemas.base.AbstractResolvedDateTime */

/** Generated avro schema for source immutable com.hubspot.chatspot.intent.schemas.chatspot.ContentRewriteRequestIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.intent.schemas.chatspot.TextGenerateRequestIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.buttons.ActionButtonV2IF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.base.JsonActionPayloadIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.buttons.LinkButtonIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.buttons.TemplateButtonIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.templates.PromptSectionIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.templates.PromptInputFieldIF */

/** Generated avro schema for subtype base java.util.Optional<com.hubspot.chatspot.intent.schemas.base.TemplatePayload> */

/** Generated avro schema for source immutable com.hubspot.chatspot.intent.schemas.chatspot.DraftSalesEmailTemplateRequestIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.intent.schemas.chatspot.NoteCreateTemplateRequestIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.intent.schemas.chatspot.TaskCreateTemplateRequestIF */

/** Generated avro schema for subtype base com.hubspot.chatspot.message.schemas.sections.metadata.MetadataField */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.metadata.AbstractBrandVoiceField */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.AbstractBarChartResponseSection */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.card.AbstractCardResponseSection */

/** Generated avro schema for subtype base com.hubspot.chatspot.message.schemas.sections.card.Card */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.card.CompanyCardIF */

/** Generated avro schema for subtype base com.hubspot.chatspot.message.schemas.sections.card.CardFieldValue */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.card.IntegerCardFieldValueIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.card.DoubleCardFieldValueIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.card.StringCardFieldValueIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.card.LinkCardFieldValueIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.base.LinkIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.AbstractDataTableResponseSection */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.table.AbstractDataTable */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.table.DataTableColumnIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.table.TableDataRowIF */

/** Generated avro schema for subtype base com.hubspot.chatspot.message.schemas.table.TableCell */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.table.PlainTextCellIF */

/** Generated avro schema for subtype base com.hubspot.chatspot.message.schemas.tokens.ResponseTextToken */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.tokens.AbstractLinkToken */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.table.ActionCellIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.table.ImageCellIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.table.LinkCellIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.AbstractHtmlTextResponseSection */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.image.AbstractImageGridResponseSection */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.image.ImageGridEntryIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.media.AbstractMediaPreviewResponseSection */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.media.ThumbnailIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.media.DescriptionIF */

/** Generated avro schema for subtype base com.hubspot.chatspot.message.schemas.sections.media.DescriptionSection */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.AbstractPlainTextResponseSection */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.media.AbstractMediaPreviewResponseSectionV2 */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.AbstractThoughtResponseSection */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.preview.ListPreviewItemIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.preview.SubHeaderIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.preview.CardPreviewItemIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.AbstractAccordionResponseSection */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.preview.CrmObjectPreviewItemIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.AbstractLlmResponseSection */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.llm.AbstractAdditionalLlmInstructions */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.llm.AbstractChatMessage */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.llm.AbstractFewShotExample */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.AbstractReportResponseSection */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.AbstractDashboardResponseSection */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.AbstractFilterBranchResponseSection */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.AbstractDenseListResponseSection */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.preview.DenseListItemIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.AbstractConfirmationResponseSection */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.AbstractUserChatResponseSection */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.AbstractUserActionResponseSection */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.useraction.UserActionPayloadIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.AbstractErrorResponseSection */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.AbstractCollaborationResponseSection */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.AbstractCrmCardResponseSection */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.crmcard.CrmCardLiteIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.AbstractVisualizationResponseSection */

/** Generated avro schema for subtype base com.hubspot.chatspot.message.schemas.sections.visualization.Visualization */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.visualization.table.TableVisualizationIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.visualization.table.TableColumnIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.visualization.VisualizationDataIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.visualization.DatasetIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.visualization.DataPropertyIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.visualization.DataFormatIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.visualization.PropertyMetaIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.visualization.PropertyReferenceIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.visualization.BaseVisualizationStyleIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.visualization.VisualizationEventsIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.visualization.datawell.DatawellVisualizationIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.visualization.datawell.DatawellLayerIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.visualization.sliced.SlicedVisualizationIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.visualization.sliced.SlicedLayerIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.visualization.xy.XYVisualizationIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.visualization.xy.XYLayerIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.visualization.xy.MarkConfigIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.visualization.xy.AxisConfigIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.visualization.xy.ColorConfigIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.visualization.sankey.SankeyVisualizationIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.visualization.sankey.SankeyLayoutIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.visualization.sankey.SankeyColumnIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.visualization.sankey.SankeyNodeIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.visualization.sankey.SankeyMeasuresIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.visualization.pivot.PivotVisualizationIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.visualization.pivot.PivotVisualizationDataIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.visualization.pivot.PivotPrimaryDataIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.visualization.pivot.PivotConfigIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.visualization.crosstab.CrossTabVisualizationIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.visualization.crosstab.CrossTabFieldIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.visualization.crosstab.CrossTabOrderIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.visualization.funnel.FunnelVisualizationIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.visualization.gauge.GaugeVisualizationIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.visualization.gauge.GaugeLayerIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.visualization.gauge.GaugePlotIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.visualization.gauge.GaugeBandIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.visualization.waterfall.WaterfallVisualizationIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.visualization.waterfall.WaterfallLayerIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.visualization.VisualizationCallbacksIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.AbstractSourcesListResponseSection */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.sources.SourcesSectionIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.sources.SourceItemIF */

/** Generated avro schema for subtype base com.hubspot.chatspot.message.schemas.sections.sources.SourceData */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.sources.WebsiteSourceDataIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.sources.AppSourceDataIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.sources.AISkillSourceDataIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.sources.CrmObjectSourceDataIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.AbstractGridResponseSection */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.grid.GridItemIF */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.AbstractTemplateResponseSection */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.AbstractUnstyledImageResponseSection */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.AbstractCardWrapperResponseSection */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.file.AbstractFileAttachmentResponseSection */

/** Generated avro schema for source immutable com.hubspot.chatspot.message.schemas.sections.file.FileAttachmentIF */

/** Generated avro schema for subtype base com.hubspot.copilot.tools.results.citations.Citation */

/** Generated avro schema for source immutable com.hubspot.copilot.tools.results.citations.DashworksCitationIF */

/** Generated avro schema for source immutable com.hubspot.copilot.tools.results.citations.CitationAuthorIF */

/** Generated avro schema for source immutable com.hubspot.copilot.tools.results.citations.CitationFeedbackIF */

/** Generated avro schema for source immutable com.hubspot.copilot.tools.results.citations.WebPageCitationIF */

/** Generated avro schema for source immutable com.hubspot.copilot.tools.results.citations.CrmCitationIF */

/** Generated avro schema for source immutable com.hubspot.copilot.tools.results.citations.LegacyCitationIF */

/** Generated avro schema for source immutable com.hubspot.copilot.tools.results.citations.CitationMetadataIF */

/** Generated avro schema for subtype base com.hubspot.copilot.models.chat.payload.AgentPayload */

/** Generated avro schema for source immutable com.hubspot.copilot.models.chat.payload.EmptyPayloadIF */

/** Generated avro schema for source immutable com.hubspot.copilot.models.chat.payload.ToolCallPayloadIF */

/**  JSON payload for the raw output response.
 */

/** Generated avro schema for source immutable com.hubspot.copilot.models.chat.MessageContextIF */

/**  Represents frontend tool execution results with status and output information.
 */

/**  Model representing a memory update event.
 */

/** Generated avro schema for source immutable com.hubspot.copilot.models.chat.CopilotMemoryIF */

/**  Represents the data sent with a COPILOT_RESPONSE_MESSAGE_DELTA event.
 */

/**  Represents the data sent with a COPILOT_RESPONSE_MESSAGE_END event.
 */

/** Generated avro schema for source immutable com.hubspot.copilot.models.chat.response.MessageStartIF */

/** Generated avro schema for source immutable com.hubspot.copilot.models.chat.response.ToolCallStartIF */

/** Generated avro schema for source immutable com.hubspot.copilot.models.chat.response.ToolCallProgressIF */

/** Generated avro schema for source immutable com.hubspot.copilot.models.chat.response.ToolCallEndIF */

/**  Represents the data sent with a COPILOT_RESPONSE_START event.
 */

/**  Represents the data sent with a COPILOT_RESPONSE_END event.
 */

/**  Represents the data sent with a COPILOT_RESPONSE_EXCEPTION event.
 */

/**  Model representing a thread title update event.
 */

/** Generated avro schema for source immutable com.hubspot.copilot.models.chat.UserInterruptIF */

/**  Request for user confirmation of an action. Sent from backend to frontend.
 Contains the message with the confirmation section that requires user response.
 */

/** Generated avro schema for source immutable com.hubspot.copilot.models.chat.ConfirmationResponseAcknowledgedIF */

/**  Interactive tool call message sent from backend to frontend.
 Contains the full message with interactive tool payload.
 */

/** Generated avro schema for source immutable com.hubspot.copilot.models.preview.PreviewStartIF */

/**  Represents the data sent with a PREVIEW_MESSAGE_DELTA event.
 */

/** Generated avro schema for source immutable com.hubspot.copilot.models.preview.PreviewEndIF */

/**  Represents the data sent with a PREVIEW_EXCEPTION event.
 */